import { Component, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';

@Component({
    selector: 'app-custom-logout',
    template: `
    <p>You have been logged out. Redirecting to login page...</p>
  `,
    standalone: false
})
export class CustomLogoutComponent implements OnInit {
  constructor(private readonly routingService: RoutingService) {}

  ngOnInit(): void {
    // Redirect to Homepage after logout
    this.routingService.go({ cxRoute: '/' });
  }
}
